import React from 'react';
import { Button } from './Button';
export function CtaSection() {
  return <section id="cta-final" className="py-24 px-4 bg-dark text-white text-center" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <h2 className="font-heading text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-35">
          Tu nueva vida comienza con una simple decisión hoy.
        </h2>
        <p className="text-xl text-white/80 mb-10" data-id="element-36">
          No dejes que tus hormonas sigan dictando cómo te sientes y cómo te
          ves.
        </p>
        <Button onClick={() => window.open('https://www.thealphamethods.com/cart/44502834249814:1', '_blank')} className="text-lg md:text-xl py-5 px-8 md:px-12" data-id="element-37">
          👉 SÍ, QUIERO RECUPERAR MI CUERPO — ACCESO INMEDIATO POR SOLO $6.36
        </Button>
        <p className="text-sm text-white/50 mt-6" data-id="element-38">
          Oferta por tiempo limitado. Acceso digital inmediato tras la compra.
        </p>
      </div>
    </section>;
}